export const GET_CURRENT_BOOKING_SLOTS_REQUEST =
  "GET_CURRENT_BOOKING_SLOTS_REQUEST";
export const GET_CURRENT_BOOKING_SLOTS_SUCCESS =
  "GET_CURRENT_BOOKING_SLOTS_SUCCESS";
export const GET_CURRENT_BOOKING_SLOTS_FAILURE =
  "GET_CURRENT_BOOKING_SLOTS_FAILURE";

export const UPDATE_BOOKING_SLOT_REQUEST = "UPDATE_BOOKING_SLOT_REQUEST";
export const UPDATE_BOOKING_SLOT_SUCCESS = "UPDATE_BOOKING_SLOT_SUCCESS";
export const UPDATE_BOOKING_SLOT_FAILURE = "UPDATE_BOOKING_SLOT_FAILURE";
